import { render, staticRenderFns } from "./DialogWrapper.vue?vue&type=template&id=a7c94c80&scoped=true"
import script from "./DialogWrapper.vue?vue&type=script&lang=js"
export * from "./DialogWrapper.vue?vue&type=script&lang=js"
import style0 from "./DialogWrapper.vue?vue&type=style&index=0&id=a7c94c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c94c80",
  null
  
)

export default component.exports